// src/menu/sections/monitorMenu.ts
import type { AppMenuEntry } from "../types";

export const MONITOR_MENU: AppMenuEntry = {
  type: "group",
  key: "monitor",
  label: "Monitor",
  children: [
    {
      key: "monitor_control",
      label: "Monitor Control",
      path: "/monitor_control",
      componentKey: "monitorControl",
      icon: "medicinebox",
    },
    {
      key: "monitors",
      label: "Monitors",
      path: "/monitors",
      resource: "monitors",
      icon: "monitor",
    },
    {
      key: "monitor_results",
      label: "Monitor Results",
      path: "/monitor_results",
      resource: "monitor_results",
      icon: "history",
    },
    {
      key: "settings",
      label: "Monitor Settings",
      path: "/settings",
      resource: "settings",
      icon: "setting",
    },
  ],
};
